import { initialize } from 'react-ga';

const UA = process.env.REACT_APP_GOOGLE_ANALYTICS_UA;

export const startGA = () => initialize(UA);
